import React, { useEffect, useState } from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import StepFooterAction from '../../base-components/step-footer-action';
import SelectMultipleInput from '../../base-components/base-input-select-multiple';
import getStep from '../../../helpers/getStep';

const IncomeSource = ({ _step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext }) => {
    const name = "income_source"
    const data = getDataFromContext(step_ID)
    const options= [
        { value: 1, label: t("financial_infos.financial_info_sources_of_income.salary"), disabled: false },
        { value: 2, label: t("financial_infos.financial_info_sources_of_income.indemnity"), disabled: false },
        { value: 3, label: t("financial_infos.financial_info_sources_of_income.Rental_income"), disabled: false },
        { value: 4, label: t("financial_infos.financial_info_sources_of_income.Real_estate_income"), disabled: false },
        { value: 5, label: t("financial_infos.financial_info_sources_of_income.pension"), disabled: false },
        { value: 6, label: t("financial_infos.financial_info_sources_of_income.other"), disabled: false },
        { value: 7, label: t("financial_infos.financial_info_sources_of_income.none"), disabled: false },
    ]
    const [defaultSelected, setDefaultSelected] = useState(data && data[name])
    const [inputData, setInputData] = useState({[name]:defaultSelected })
    const [isLoading, setIsLoading] = useState(false)
    const [isValid, setIsValid] = useState(false)
    const [optionList, setOptionList] = useState([...options])
    const [nextTick, setNextTick] = useState(false)

    const getInputValue = (name, value, uVal) => {
        console.log('getinputvalue = ', value, uVal)
        let _value = value
        checkOption(_value)
        let validCheck =  _value
        setIsValid(validCheck.length > 0 && validCheck !== "")
        setInputData({
            [name]: _value
        })
    }

    const checkOption = (val) => {
        if (val.includes("7")) {
            setInputData({
                [name]: 7
            })
            setDefaultSelected("")
            setOptionList([...optionList.map(option => (
                    {
                        value: option.value,
                        label: option.label,
                        disabled: (option.value !== 7 ) ? option.disabled = true : option.disabled = false
                    }
                )
            )])
        } else {
            if(options !== optionList) setOptionList([...options])
        }
    }

    const handleOtherSource = () => {
        _step_service({ step_ID, setIsLoading, next_step: "income-source-other"})
    }

    const action = () => {
        setDataToContext(step_ID, step_URL, step_ID, inputData[name]) 
        setNextTick(true)
    }

    useEffect(() => {
        if (nextTick) {
         if (inputData[name].includes('6')) { _step_service({ step_ID, setIsLoading, next_step: "income-source-other"}) } else {_step_service({ step_ID, setIsLoading, next_step:"fiscal-residence" }) }
      } 
    }, [nextTick])

    useEffect(() => {
        getStep(['income_source']).then(res => {
            setDefaultSelected(res[name] !== "NULL" ? res[name] : "")
            setIsValid(res !== "" & res.income_source !== "NULL")
            setInputData({[name]:res[name]})
            setDataToContext(step_ID, step_URL, step_ID, res[name]) 
        })
        
                        if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                    pageID: "onboarding",
                    stepSeq: "2",
                    stepName: "financial info:sources of income",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    trackMethod: "flow"
                    }
                );
            }
    }, [])


    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{ t("financial_infos.financial_info_sources_of_income.title")}</h3>
                    <p>{ t("financial_infos.financial_info_sources_of_income.text")}</p>
                </BaseParagraph>

                <SelectMultipleInput type={"multiple-select"} name={name}
                    options={optionList}
                    getInputValue={getInputValue}
                    value={inputData[step_ID]}
                    soloVal={7}
                    defaultSelect={defaultSelected ? defaultSelected : ""}
                />

                <StepFooterAction caption={t('general.continue')}  action={action} disabled={!isValid} />
            </StepsLoader>
        </>
    )
}

IncomeSource.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}

export default IncomeSource